import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import './SubNavigationLayout.scss';

type Props = {
    /**
     * Indicates whether the sub navigation should be rendered with a layout intended for the sticky header.
     */
    readonly isSticky?: boolean;

    /**
     * Controls the width of the left & right sections.
     * The given value specifies the width of those sections as a percentage.
     *
     * NOTE: This setting has no effect if `isSticky` is `true`.
     */
    readonly width?: '0' | '15' | '20' | '30' | '35' | '50';

    readonly className?: string;

    readonly left?: ReactNode;
    readonly center?: ReactNode;
    readonly right?: ReactNode;
};

const SubNavigationLayout: FC<Props> = ({ isSticky, width, className, left, center, right }) => {
    return (
        <div
            className={classNames(
                'sub-nav',
                isSticky && 'sub-nav--sticky',
                !isSticky && width && `sub-nav--${width}`,
                className
            )}
        >
            <div className="sub-nav-left">{left}</div>
            {center}
            <div className="sub-nav-right">{right}</div>
        </div>
    );
};

export default SubNavigationLayout;
